import * as React from 'react';
import LetterCell from './letterCell';
import Date from './getDate';

export default class LetterGroup extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        const {data,extraData} = this.props;
        return(
            <div className="noteListingGroup detailListingGroup">

                <div className="date"><Date inputDate={data} /></div>
                {data.data.map((d)=>{
                    return <React.Fragment key={d.id}><LetterCell data={d.data} extraData={extraData} onCellClick={this.props.onCellClick} onItemClick={this.props.onItemClick} /></React.Fragment>
                })}
            </div>
        );
    }
}